import { MaintenanceForwardingCheckinEntryTransportAutoEntryData } from "./transport/autoEntry/transportAutoEntry.type";

export enum MaintenanceForwardingCheckinEntryKlass {
  TransportAutoEntry = 'Maintenance::Transport::AutoEntry',
}

export type MaintenanceForwardingCheckinEntryMap = {
  [MaintenanceForwardingCheckinEntryKlass.TransportAutoEntry]: MaintenanceForwardingCheckinEntryTransportAutoEntryData;
}
